<form class="grid gap-4 pt-2" [formGroup]="divisionForm" (ngSubmit)="submit()">
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>{{ label() }} *</mat-label>
    <input matInput formControlName="name" placeholder="Enter name" />
    @if (divisionForm.controls.name.invalid && divisionForm.controls.name.touched) {
      <mat-error>{{ label() }} is required.</mat-error>
    }
  </mat-form-field>

  <div class="flex justify-end pt-2">
    <button mat-raised-button color="primary" type="submit" [disabled]="divisionForm.invalid || saving()">
      @if (saving()) {
        <mat-spinner diameter="20" class="mr-2" />
      }
      Save
    </button>
  </div>
</form>
